import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  FormHelperText,
  FormGroup,
} from "@mui/material";
import { Controller, useController } from "react-hook-form";

const CheckboxList = ({
  children,
  control,
  name,
  label,
  options,
  rules,
  defaultValue,
  ...props
}) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
    rules,
    defaultValue: defaultValue || [],
  });

  const [items, setItems] = useState(value ? value : []);

  useEffect(() => {
    onChange(items);
  }, [items]);

  const handleCheckboxChange = (event) => {
    const id = event.target.id;
    setItems((currentParticipants) =>
      currentParticipants && currentParticipants.includes(id)
        ? currentParticipants.filter((f) => f !== id)
        : [...currentParticipants, id]
    );
  };

  return (
    <FormControl error={props.error}>
      <FormGroup onChange={handleCheckboxChange}>
        {options &&
          options.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  id={item.value}
                  checked={items.includes(item.value)}
                />
              }
              label={item.text}
            />
          ))}

        {props.extraOptions &&
          props.extraOptions.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  id={item.value}
                  checked={items.includes(item.value)}
                />
              }
              label={item.text}
            />
          ))}
      </FormGroup>
      <FormHelperText>{props.helperText}</FormHelperText>
    </FormControl>
  );
};

export default CheckboxList;
